module.exports = {"aspectRatio":6.7727272727272725}